export const cintraHrLogRoutes = {
  hub: 'hrlog/hub'
};
